export default __webpack_public_path__ + "static/media/search.06ab50db.svg";